(() => {
  "use strict";

  class CartBar extends HTMLElement {
    constructor() {
      super();

      this.section = null;
      this.form = null;
      this.formWrapper = null;

      this.handleClick = this.handleClick.bind(this);
      this.handleProductAddError =
        this.handleProductAddError.bind(this);
      this.toggleCartBarOnScroll =
        this.toggleCartBarOnScroll.bind(this);
      this.setCartBarHeight =
        this.setCartBarHeight.bind(this);

      this.initialVisibilityDelay = 1000;
      this.initialVisibilityTimer = null;
    }

    connectedCallback() {
      this.section = this.closest("product-info");

      if (!this.section) {
        return;
      }

      if (
        sessionStorage.getItem(
          "cartBarColorChangeScrollTop"
        ) === "true"
      ) {
        sessionStorage.removeItem(
          "cartBarColorChangeScrollTop"
        );

        requestAnimationFrame(() => {
          window.scrollTo({
            top: 0,
            behavior: "auto",
          });
        });
      }

      this.form = this.section.querySelector(
        "[data-product-form]"
      );

      this.formWrapper =
        theme.settings.productPageSticky &&
          this.section.querySelector("[data-form-wrapper]")
          ? this.section.querySelector("[data-form-wrapper]")
          : this.form;

      this.setCartBarHeight();

      this.addEventListener(
        "click",
        this.handleClick
      );

      document.addEventListener(
        "theme:scroll",
        this.toggleCartBarOnScroll
      );

      document.addEventListener(
        "theme:resize",
        this.setCartBarHeight
      );

      document.addEventListener(
        "theme:product:add-error",
        this.handleProductAddError
      );

      /*
 * Durante el primer segundo el componente existe
 * pero permanece visualmente bloqueado.
 *
 * Después recalculamos inmediatamente si debe
 * mostrarse según la posición del ATC principal.
 */
      this.initialVisibilityTimer =
        window.setTimeout(() => {
          this.classList.add(
            "is-cart-bar-ready"
          );

          this.toggleCartBarOnScroll();
        }, this.initialVisibilityDelay);
    }

    disconnectedCallback() {
      if (this.initialVisibilityTimer) {
        window.clearTimeout(
          this.initialVisibilityTimer
        );

        this.initialVisibilityTimer = null;
      }

      this.removeEventListener(
        "click",
        this.handleClick
      );

      document.removeEventListener(
        "theme:scroll",
        this.toggleCartBarOnScroll
      );

      document.removeEventListener(
        "theme:resize",
        this.setCartBarHeight
      );

      document.removeEventListener(
        "theme:product:add-error",
        this.handleProductAddError
      );
    }

    scrollToProductTop() {
      const productSection = this.section;

      if (!productSection) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      const top =
        productSection.getBoundingClientRect().top +
        window.scrollY;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth",
      });
    }

    handleClick(event) {
      const addButton = event.target.closest(
        "[data-cart-bar-add-to-cart]"
      );

      if (addButton) {
        event.preventDefault();

        const isMobile =
          window.matchMedia(
            "(max-width: 749px)"
          ).matches;

        if (isMobile) {
          this.openQuickAdd(addButton);
          return;
        }

        this.addToCart(
          addButton,
          event
        );

        return;
      }

      const colorButton = event.target.closest(
        "[data-cart-bar-color]"
      );

      if (colorButton) {
        event.preventDefault();
        this.selectColor(colorButton);
        return;
      }

      const moreColorsButton = event.target.closest(
        "[data-cart-bar-scroll-to-colors]"
      );

      if (moreColorsButton) {
        event.preventDefault();
        this.scrollToColors();
      }
    }

    openQuickAdd(button) {
      const productId =
        this.dataset.productId || "";

      const productHandle =
        this.dataset.productHandle || "";

      const productUrl =
        this.dataset.productUrl || "";

      const quickBuyUrl =
        this.dataset.quickBuyUrl || "";

      document.dispatchEvent(
        new CustomEvent(
          "nosto:quick-buy:open",
          {
            bubbles: true,
            detail: {
              productId,
              productHandle,
              productUrl,
              quickBuyUrl,
              button,
              source: "cart-bar",
            },
          }
        )
      );
    }

    addToCart(button, event) {
      if (button.disabled || !this.form) {
        return;
      }

      const productForm = this.form.closest(
        "product-form"
      );

      if (
        !productForm ||
        typeof productForm.onSubmitHandler !== "function"
      ) {
        console.error(
          "[CartBar] No se encontró el formulario principal."
        );
        return;
      }

      button.classList.add("is-loading");
      button.setAttribute("disabled", "disabled");

      productForm.onSubmitHandler(event);
    }

    selectColor(button) {
      if (
        button.disabled ||
        button.getAttribute("aria-pressed") === "true"
      ) {
        return;
      }

      /*
 * La PDP va a cambiar de producto.
 *
 * Ocultamos inmediatamente la cart bar actual
 * para que no permanezca visible durante la
 * transición al nuevo color.
 */
      this.classList.add(
        "is-changing-product"
      );

      this.classList.remove(
        "is-visible"
      );

      sessionStorage.setItem(
        "cartBarColorChangeScrollTop",
        "true"
      );

      this.scrollToProductTop();

      const productHandle =
        button.dataset.productHandle;

      const productUrl =
        button.dataset.productUrl;

      const colorPicker = this.section.querySelector(
        "product-color-products"
      );

      if (!colorPicker) {
        if (productUrl) {
          window.location.href = productUrl;
        }

        return;
      }

      const selector = productHandle
        ? `[data-product-color-link][data-product-handle="${CSS.escape(
          productHandle
        )}"]`
        : null;

      const originalColorLink = selector
        ? colorPicker.querySelector(selector)
        : null;

      if (originalColorLink) {
        originalColorLink.click();
        return;
      }

      /*
       * Respaldo para casos donde el enlace no esté presente
       * en el selector principal.
       */
      if (
        productUrl &&
        typeof colorPicker.loadProduct === "function"
      ) {
        colorPicker.loadProduct({
          url: productUrl,
          trigger: null,
          updateHistory: true,
        });

        return;
      }

      if (productUrl) {
        window.location.href = productUrl;
      }
    }

    scrollToColors() {
      const colorPicker = this.section.querySelector(
        "product-color-products"
      );

      if (!colorPicker) {
        return;
      }

      const top =
        colorPicker.getBoundingClientRect().top +
        window.scrollY;

      window.theme.scrollTo(
        top - 20
      );
    }

    handleProductAddError() {
      const addButton = this.querySelector(
        "[data-cart-bar-add-to-cart]"
      );

      if (addButton) {
        addButton.classList.remove("is-loading");
        this.scrollToForm();
      }
    }

    scrollToForm() {
      const variantSelectors =
        this.section.querySelector("variant-selects");

      const target =
        theme.isMobile
          ? variantSelectors || this.form
          : this.section;

      if (!target) {
        return;
      }

      const top =
        target.getBoundingClientRect().top +
        window.scrollY;

      window.theme.scrollTo(
        theme.isMobile ? top - 10 : top
      );
    }

    toggleCartBarOnScroll() {
      /*
      * Durante el cambio de producto/color
      * nunca permitimos mostrar la cart bar.
      */
      if (
        this.classList.contains(
          "is-changing-product"
        )
      ) {
        this.classList.remove(
          "is-visible"
        );

        return;
      }

      /*
      * Botón principal de compra.
      */
      const mainPurchaseButton =
        this.section.querySelector(
          ".product-purchase-actions__main"
        );

      if (!mainPurchaseButton) {
        this.classList.remove(
          "is-visible"
        );

        return;
      }

      const buttonRect =
        mainPurchaseButton.getBoundingClientRect();

      /*
      * El botón está dentro del viewport
      * cuando su parte inferior está por debajo
      * de 0 y su parte superior está antes
      * de la altura del viewport.
      */
      const isButtonInViewport =
        buttonRect.bottom > 0 &&
        buttonRect.top < window.innerHeight;

      /*
      * Mostrar la cart bar únicamente cuando
      * el botón NO está visible.
      */
      const shouldShow =
        !isButtonInViewport;

      this.classList.toggle(
        "is-visible",
        shouldShow
      );
    } 

    setCartBarHeight() {
      const height = this.offsetHeight;

      document.documentElement.style.setProperty(
        "--cart-bar-height",
        `${height}px`
      );
    }
  }

  if (!customElements.get("cart-bar")) {
    customElements.define(
      "cart-bar",
      CartBar
    );
  }
})();